import { SaveRecordAction } from '@aibees/elephant/hooks';
import { useEnrichPersonSaveRecord } from '@aibees/elephant/hooks/people/use-enrich-person-save-record';
import { useSaveRecordEnrichableCount } from '@aibees/elephant/hooks/people/use-save-record-enrichable-count';
import { CreditUsageType } from '@aibees/shared/definition';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { InfoItem } from '../enrich-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichJobChangeDialogProps as Props } from './types';

export const EnrichJobChangeDialog = memo(
  ({ className, onClose, open, table }: Props) => {
    const { enrichable, isLoading: countLoading } =
      useSaveRecordEnrichableCount(
        SaveRecordAction.CONTACT_UPDATE_JOB_CHANGE,
        open ? table : undefined
      );

    const { credit } = useCreditUsageItem(CreditUsageType.CONTACT_JOB_CHANGE);

    const { handleEnrich, isLoading } = useEnrichPersonSaveRecord(
      SaveRecordAction.CONTACT_UPDATE_JOB_CHANGE,
      onClose,
      table,
      enrichable
    );

    const informations: InfoItem[] = [
      { count: enrichable, label: 'records have job changes.' },
      // { count: unEnrichable, label: 'records have not job changes' },
    ];

    return (
      <Styled.Wrapper
        className={classnames('EnrichJobChangeDialog', className)}
        sx={SX.root}
        open={open}
        onClose={onClose}
        icon="briefcase-arrow-left-right-outline"
        submitButtonText="Update"
        title="Update Job Changes"
        informations={informations}
        cost={credit}
        onSubmit={handleEnrich}
        enrichLoading={isLoading}
        countLoading={countLoading}
        recordsCount={table?.selection.included.length || 0}
        disableEnrich={!enrichable || enrichable === 0}
        unEnrichableHelperText="The job changes for selected contacts are processed and don’t need enrichment."
        costText="contact"
      />
    );
  }
);

EnrichJobChangeDialog.displayName = 'EnrichJobChangeDialog';
